import { consoleLog } from "../../../Common/GlobalFunc";
import { isLocalMeeting } from '../../../Common/home-common';
import moment from 'moment'


export const getOddsValue = (odds, cmbSt) => {
    switch (cmbSt.toLowerCase()) {
        case "scratched":
        case "scratch":
        case "substitute":
            return "SCR";
        case "reservedorrefunded":
        case "refunded":
        case "reserved":
        case "reserve":
            return "---";
        
    }
    if(Number(odds) === 0){
        return '---'
    }
    return odds;
}

export const parseExprCombStr = (combStr) => {

    let combStrArray = combStr.split("+").map(item => Number(item) >= 10 ? item : `0${Number(item)}`)
    if(combStr.includes('/')){
        combStrArray = combStr.split("/").map(item => Number(item) >= 10 ? item : `0${Number(item)}`)
        return combStrArray.join('/')
    }

    return combStrArray.join(",")
}


// export const getCurrentRaceNo = (content) => {
//     if(!content.meeting) return null
//     const meeting = content.meeting
//     let currentNumberOfRace = meeting?.currentNumberOfRace
//     let isLoacl = isLocalMeeting(meeting.venueCode)
//     if((isLoacl && window.globalConfig.LOCAL_EXPRESS_ODDS_PUSH) || (!isLoacl && window.globalConfig.OVERSEA_EXPRESS_ODDS_PUSH) || currentNumberOfRace == 0) return currentNumberOfRace
//     return 0
// }
const replaceRacingTopicString = (content, tKey, allRaces,raceNo) => {
    consoleLog("content",content);
    const isExpressPush = window.globalConfig.EXPRESS_ODDS_PUSH
    const isExpress2Push = window.globalConfig.EXPRESS_ODDS_PUSH2
    const isPushV2 = window.globalConfig.ODDS_PUSH_V2
    let curTopic = content?.config?.pushTopics?.[tKey]
    if(isPushV2){
        curTopic = curTopic.replace('evt/01/','evt/02/')
    }
    if(isExpressPush){
        curTopic = content?.config?.pushTopics?.[`${tKey}_EXPRESS`] || curTopic
    }

    if(isExpress2Push){
        curTopic = content?.config?.pushTopics?.[`${tKey}_EXPRESS2`] || curTopic
    }
    raceNo = raceNo ? raceNo : content.raceNo
    raceNo = raceNo >= 10 ? raceNo : `0${raceNo}`

    return curTopic
        ?.replace('{dt}', content.date?.replace(/-/g, ''))
        ?.replace('{ve}', content.venue.toLowerCase())
        ?.replace('{no}', allRaces ? '+' : raceNo);
}

const replaceIdaPushTopic = (content, tKey, allRaces,raceNo) =>{
    let curTopic = content?.config?.pushTopics?.[tKey]
    raceNo = raceNo ? raceNo : content.raceNo
    raceNo = raceNo >= 10 ? raceNo : `0${raceNo}`
    const isPushV2 = window.globalConfig.ODDS_PUSH_V2
    if(isPushV2){
        curTopic = curTopic.replace('evt/01/','evt/02/')
    }
    return curTopic
        ?.replace('{dt}', content.date?.replace(/-/g, ''))
        ?.replace('{ve}', content.venue.toLowerCase())
        ?.replace('{no}', allRaces ? '+' : raceNo);
}

// const replaceExprTopicString = (content, tKey, allRaces) => {
//     const isExpressPush = window.globalConfig.EXPRESS_ODDS_PUSH
//     const isExpressPush2 = window.globalConfig.EXPRESS_ODDS_PUSH2
//     let currentNumberOfRace = content?.meeting?.currentNumberOfRace
//     let odpsTopic
//     let isLoacl = isLocalMeeting(content?.meeting?.venueCode)
//     if(isLoacl && !window.globalConfig.LOCAL_EXPRESS_ODDS_PUSH) return null
//     if(!isLoacl && !window.globalConfig.OVERSEA_EXPRESS_ODDS_PUSH) return null
//     if(!allRaces && currentNumberOfRace == 0) return null
//     if(isExpressPush){
//         odpsTopic = content?.config?.pushTopics?.[`${tKey}_EXPRESS`]
//     }
//     if(isExpressPush2 && !odpsTopic){
//         odpsTopic = content?.config?.pushTopics?.[`${tKey}_EXPRESS2`]
//     }
//     let raceNo = currentNumberOfRace > 10 ? currentNumberOfRace : `0${currentNumberOfRace}`
//     return odpsTopic
//         ?.replace('{dt}', content.date?.replace(/-/g, ''))
//         ?.replace('{ve}', content.venue.toLowerCase())
//         ?.replace('{no}', allRaces ? '+' : raceNo);
// }

export const getRacingTopics = (content) => {
        let list = []
        consoleLog("content.page",content.page);
        let idaPushComingleRaces = []
        if(window.globalConfig.EXPRESS_OB_IDA_PUSH && content.meeting?.obSt){
            idaPushComingleRaces = content.meeting.obSt.reduce((array, data) => {
               if(data.comingleStatus == "1" || data.comingleStatus == "2"){
                   if(!array.includes(data.leg.races[0])){
                       array.push(data.leg.races[0])
                   }
               }
               return array
           },[])
        }

        switch (content.page) {
            case 'HORSE_SELECTOR':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "PLA", true));
                list.push(replaceRacingTopicString(content, "QIN", true));
                list.push(replaceRacingTopicString(content, "QPL", true));
                list.push(replaceRacingTopicString(content, "FCT", true));
                list.push(replaceRacingTopicString(content, "TRI", true));
                list.push(replaceRacingTopicString(content, "FF", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'WP':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "PLA", true));
                list.push(replaceRacingTopicString(content, "ALL_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                if(window.globalConfig.EXPRESS_ODDS_PUSH2){
                    list.push(replaceRacingTopicString(content, "QIN", true));
                    list.push(replaceRacingTopicString(content, "QPL", true));
                    list.push(replaceRacingTopicString(content, "DBL", true));
                }
                break;
            case 'TURNOVER':
                list.push(replaceRacingTopicString(content, "ALL_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                if(window.globalConfig.EXPRESS_ODDS_PUSH){
                    list.push(replaceRacingTopicString(content, "WIN", true));
                    list.push(replaceRacingTopicString(content, "PLA", true));
                }
                if(window.globalConfig.EXPRESS_ODDS_PUSH2){
                    list.push(replaceRacingTopicString(content, "QIN", true));
                    list.push(replaceRacingTopicString(content, "QPL", true));
                    list.push(replaceRacingTopicString(content, "DBL", true));
                }
                break;
            // case 'HOME':
            //         list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
            //         list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
            //         break;
            case 'PWIN':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "PLA", true));
                list.push(replaceRacingTopicString(content, "PWIN0", true));
                list.push(replaceRacingTopicString(content, "PWIN1", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'JTCOMBO':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "PLA", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'WPQ':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "PLA", true));
                list.push(replaceRacingTopicString(content, "QIN", true));
                list.push(replaceRacingTopicString(content, "QPL", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'IWN':
            case 'FCT':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, content.page, true));
                list.push(replaceRacingTopicString(content, content.page + "_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'CWB':
            case 'CWC':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, content.page, true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'CROSS_ALUP':
            case 'WPALUP':
            case 'WPQALUP':
            case 'FCTALUP':
            case 'TRIALUP':
            case 'CWA':
            case 'CWAALUP':
            case 'CWAALLALUP':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, "CWA", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'DBL':
                list.push(replaceRacingTopicString(content, "WIN", true));
                if(idaPushComingleRaces.length > 0 && window.globalConfig.EXPRESS_ODDS_PUSH2){
                    content.meeting.races.forEach(race => {
                        if(idaPushComingleRaces.includes(race.no)){
                            list.push(replaceIdaPushTopic(content, "DBL", false, race.no));
                        }else{
                            list.push(replaceRacingTopicString(content, "DBL", false, race.no));
                        }
                    });
                }else{
                    list.push(replaceRacingTopicString(content, "DBL", true));
                }
                list.push(replaceRacingTopicString(content, content.page + "_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'TBL':
            case 'DT':
            case 'TT':
            case '6UP':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content, content.page + "_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                break;
            case 'TCE':
            case 'TRI':
            case 'QTT':
            case 'FF':
                list.push(replaceRacingTopicString(content, "WIN", true));
                list.push(replaceRacingTopicString(content, content.page + "_INV", true));
                list.push(replaceRacingTopicString(content,  "ALL_SEL", true));
                list.push(replaceRacingTopicString(content,  "ALL_RAC", true));
                list.push(replaceRacingTopicString(content,  "ALL_MEE", true));
                if ( content.displayOpt==="top" ) {
                    list.push(replaceRacingTopicString(content, content.page + "_TOP", true));
                }
                else if ( content.displayOpt==="banker" ) {
                    list.push(replaceRacingTopicString(content, content.page + "_BANK", true));
                }
                else if ( ["TRI", "FF"].includes(content.page) ) {
                    list.push(replaceRacingTopicString(content, content.page, true));
                }
                break;
            case 'JKC':
                list.push(replaceRacingTopicString(content, "JKC_ODD", true));
                list.push(replaceRacingTopicString(content, "JKC_STA", true));
                list.push(replaceRacingTopicString(content, "JKC_DET", true));
                list.push(replaceRacingTopicString(content,  "JKC_SEL", true));
                break;
            case 'TNC':
                list.push(replaceRacingTopicString(content, "TNC_ODD", true));
                list.push(replaceRacingTopicString(content, "TNC_STA", true));
                list.push(replaceRacingTopicString(content, "TNC_DET", true));
                list.push(replaceRacingTopicString(content,  "TNC_SEL", true));
                break;
            }
        return list;
    }
